import React from "react";
import { Option, None } from "@swiggy-private/js-fp";
import { User } from "@checkout-core/interfaces/User";

export interface UserContextValue {
    user: Option<User>;
    setUser: (user: User) => void;
}

export const UserContext = React.createContext<UserContextValue>({
    user: None,
    setUser: _user => void 0,
});
